import axios from "axios";
const jsonConfig = require("../../Config.json");

const getToken = async (jdId) => {
    let allResponse = {}
    try {
        allResponse = await axios.get(`${jsonConfig.apiUrl}gettoken/${jdId}`, {
            headers: {
                "x-functions-key": jsonConfig.key,
            }
        });
        
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default getToken;

